module.exports = __webpack_public_path__ + "img/2.d17b20d4.jpg";